import Navbar from './components/Navbar/Navbar';
import { HelpSection } from './components/HelpSection/HelpSection';
import { PortfolioSection } from './components/PortfolioSection/PortfolioSection';
import { TestimonialsSection } from './components/TestimonialsSection/TestimonialsSection';
import { ContactSection } from './components/ContactSection/ContactSection';
import { Hero } from './components/Hero/Hero';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HelpSection />
        <PortfolioSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
    </>
  );
}

export default App;
